module.exports = __webpack_public_path__ + "img/icon-whatsapp-outline.ef6fb5e.svg";